import { ApiStockObjTypes, type StockObj } from "@src/api/stock/stockObjs";

/**
 * Возвращает строковое описание типа объекта склада на основе значения BaseType.
 *
 * @param stockObj - Объект склада (ТМЦ)
 * @returns Строковое описание типа объекта склада.
 */
export const formatStockObjTypeName = (stockObj?: StockObj): string => {
    if (stockObj == null) return "Не задан";

    // Если BaseType === 0, берем значение из KoTypeObject
    if (stockObj.BaseType === ApiStockObjTypes.Ko) {
        return stockObj.KoTypeObj?.Shortname ?? "Не задан";
    }

    // В остальных случаях возвращаем строку на основе BaseType
    switch (stockObj.BaseType) {
        case ApiStockObjTypes.Material:
            return "Материал";
        case ApiStockObjTypes.Other:
            return "Другие ТМЦ";
        case ApiStockObjTypes.Tare:
            return "Тара";
        case ApiStockObjTypes.KSpec:
            return "Контр. спец";
        default:
            return "Не задан"; // Значение по умолчанию для нераспознанных BaseType
    }
};
